import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Checkbox, notification, NOTIFICATION_TYPES, Popup, Typography } from '_atoms';
import { reviewCandidate } from 'actions';
import type { Uuid } from 'store/reducers/types';
import './style.scss';

interface PopupMarkAsReviewedProps {
  open: boolean;
  onClose: () => void;
  candidateUuid?: Uuid;
  candidateName?: string;
  onReviewed: () => void;
}

export const PopupMarkAsReviewed: React.FC<PopupMarkAsReviewedProps> = ({
  open,
  onClose,
  candidateUuid,
  candidateName,
  onReviewed,
}) => {
  const { t } = useTranslation();
  const [sendRejectionEmail, setSendRejectionEmail] = useState(true);
  const [loading, setLoading] = useState(false);

  const onClosePopup = () => {
    setSendRejectionEmail(true);
    onClose();
  };

  const onMark = () => {
    setLoading(true);
    reviewCandidate(candidateUuid, sendRejectionEmail)
      .then(() => {
        notification({
          message: t(
            sendRejectionEmail
              ? 'translation:popup_mark_as_reviewed.text_reviewed_email_sent'
              : 'translation:popup_mark_as_reviewed.text_reviewed'
          ),
          type: NOTIFICATION_TYPES.SUCCESS,
        });
        onReviewed();
        onClosePopup();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Popup
      open={open}
      className="popup-mark-as-reviewed"
      title={t('translation:popup_mark_as_reviewed.title')}
      loading={loading}
      cancelButtonProps={{
        children: t('translation:popup_mark_as_reviewed.button_cancel'),
        onClick: onClosePopup,
      }}
      okButtonProps={{
        children: t('translation:popup_mark_as_reviewed.button_mark'),
        onClick: onMark,
      }}
    >
      <Typography.Text>
        <Trans
          /* @ts-expect-error react-i18next Trans i18nKey typing conflicts with the strict resources union */
          i18nKey="translation:popup_mark_as_reviewed.text_confirm"
          values={{ name: candidateName }}
          components={{ strong: <strong /> }}
        />
      </Typography.Text>
      <Checkbox
        label={t('translation:popup_mark_as_reviewed.checkbox_send_rejection_email')}
        isSelected={sendRejectionEmail}
        onChange={e => setSendRejectionEmail(e.target.checked)}
      />
    </Popup>
  );
};
